<template>
  <div>
    <top-navbar />
    <main-header></main-header>
    <wegow-recommendations />
    <basic-footer />
    <modal-success
      v-if="successModal"
      text="Inicio de sesión realizado con éxito"
      @accept="closeModal"
    />

    <!-- <ga-pixel v-if="artist?.google_pixel_js" :pixel="artist.google_pixel_js" /> -->
    <Fb-pixel :pixel="`fbq('addPixelId', '${fbPixel}')`" />
  </div>
</template>

<script setup>
import { useUser } from "@/composables/useUser";

import TopNavbar from "@/components/general/ui/navbar/TopNavbar";
import MainHeader from "@/components/wegow/ui/headers/MainHeader";
import WegowRecommendations from "@/components/wegow/recommendations/WegowRecommendations";
import BasicFooter from "@/components/general/ui/footer/BasicFooter";
import ModalSuccess from "@/components/general/modals/ModalSuccess.vue";
import { useI18n } from "vue-i18n";
import { metas } from "@/plugins/mixins/metas";
import { event } from "vue-gtag";
import FbPixel from "@/components/general/FbPixel";
// import GaPixel from "@/components/general/GaPixel";

import { useRoute, useRouter } from "vue-router";
import { onMounted, onBeforeMount, ref } from "vue";

const { confirmEmail } = useUser();
const { t } = useI18n();
const router = useRouter();
const route = useRoute();
const successModal = ref(false);
const fbPixel = ref(Number(process.env.VUE_APP_FACEBOOK_PIXEL));

onMounted(async () => {
  metas.methods.setLanguage();
  metas.methods.setCanonical();

  if (route.query["confirm-email"]) {
    await confirmEmail(route.query["confirm-email"]);
    router
      .push({
        path: route.path,
        query: {}
      })
      .catch(error => {
        console.error(error);
      });
  }
  if (route.query.la === "true" && route.query.login === "success") {
    successModal.value = true;
    event("livingApps", {
      event_category: "Login",
      event_label: "success",
      user_id: userDetail.value.id,
      non_interaction: true
    });
  }
});
onBeforeMount(() => {
  metas.methods.setMetasHtml(
    {
      title: t("general.metas.homeTitle"),
      description: t("general.metas.homeDescription")
    },
    route,
    router
  );
  metas.methods.setOpenGraph({
    title: t("general.metas.homeTitle"),
    description: t("general.metas.homeDescription"),
    image: "@/public/favicons/favicon-36x36.png"
  });

  // Twitter graph
  metas.methods.setTwitterCard({
    title: t("general.metas.homeTitle"),
    description: t("general.metas.homeDescription"),
    image: "@/public/favicons/favicon-36x36.png"
  });
  // Schema
  let schema = {
    "@context": "http://schema.org",
    "@type": "WebPage",
    name: t("general.metas.homeTitle"),
    url: "https://www.wegow.com",
    description: t("general.metas.homeDescription"),
    isPartOf: {
      "@type": "WebSite",
      url: "https://www.wegow.com"
    }
  };
  let script = document.createElement("script");
  script.type = "application/ld+json";
  script.innerHTML = JSON.stringify(schema);
  document.head.appendChild(script);
});
const closeModal = () => {
  successModal.value = false;
  let url = new URL(window.location.href);
  url.searchParams.delete("login");
  url.searchParams.delete("la");
  history.replaceState({}, "", url.href);
};
</script>

<style lang="scss">
body {
  background-color: $backgroundBlack !important;
  margin: 0px;
  // TODO: cambiar a variable
}
// div {
//   color: white;
// }
</style>
